module.exports = __webpack_public_path__ + "img/pumpkin.c91fbf57.png";